"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useInsuranceDetailsContent = _interopRequireDefault(require("../../../hooks/upsell/useInsuranceDetailsContent"));
var _services = require("../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useUpsell = _interopRequireDefault(require("../../../hooks/upsell/useUpsell"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ButtonWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const InsuranceDetailsBody = () => {
  const {
    product,
    onClick,
    isSelected
  } = (0, _useInsuranceDetailsContent.default)();
  const {
    isDisabled
  } = (0, _useUpsell.default)();
  const buttonText = isSelected(product) ? _services.locale.localeString('RelationshipOffer.RemoveFromCart') : _services.locale.localeString('RelationshipOffer.AddToCart');
  const buttonAppearance = isSelected(product) ? 'primary' : 'secondary';
  const buttonState = isDisabled(product.productType.toLowerCase(), product.id) ? 'disabled' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "insurance-details-body"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 8,
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: _services.locale.localeString('RelationshipOffer.InsuranceDetails'),
    justify: 'center',
    weight: 3,
    size: 2
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: product.name,
    size: 3
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, null, product.description))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    text: buttonText,
    appearance: buttonAppearance,
    state: buttonState,
    onClick: () => {
      onClick(product);
    }
  }))))));
};
var _default = InsuranceDetailsBody;
exports.default = _default;